import React, { forwardRef } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Colors,
    PointElement,
    LineElement,
    LineController,
    BarController,
    Filler,
} from "chart.js";
import { Chart } from "react-chartjs-2";

const QuantGraphGlobal = forwardRef(({ variants, initData, kpi, goal }, ref) => {
    const decoratedData = [
        {
            label: "Doel" + (kpi.maximize ? "(min)" : "(max)"),
            data: Array(variants.length).fill(goal.value),
            type: "line",
            borderWidth: 3,
            borderColor: "red",
            legendColor: "red",
            pointStyle: false,
            borderDash: [8, 8],
            order: 1, // Lines appear on top
        },
        {
            ...initData,
            label: "Totaal",
            order: 2, // Bars appear below lines
        },
    ];

    ChartJS.register(
        LinearScale,
        CategoryScale,
        BarElement,
        PointElement,
        LineElement,
        Legend,
        Tooltip,
        LineController,
        BarController,
        Colors,
        Title,
        Filler
    );

    const options = {
        plugins: {
            title: {
                display: true,
                text: kpi.name,
                font: {
                    size: 14,
                },
            },
            filler: {
                propagate: true,
            },
            legend: {
                display: true,
                align: "start",
                position: "chartArea",
                labels: {
                    filter: function (legendItem) {
                        return legendItem.text !== "Totaal";
                    },
                    generateLabels: function(chart) {
                        const datasets = chart.data.datasets;
                        
                        return datasets.map((dataset, i) => {
                            const isLine = dataset.type === 'line';
                            const color = dataset.legendColor || (Array.isArray(dataset.backgroundColor) ? dataset.backgroundColor[0] : dataset.backgroundColor);
                            return {
                                text: dataset.label,
                                fillStyle: isLine ? 'transparent' : color,
                                strokeStyle: color,
                                lineWidth: isLine ? 3 : 0,
                                lineDash: isLine && dataset.borderDash ? dataset.borderDash : [],
                                hidden: !chart.isDatasetVisible(i),
                                index: i,
                        }
                    })
                    }
                },
            },
        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: kpi.unit,
                },
                afterDataLimits: function(scale) {
                    scale.max = scale.max * 1.01
                },
            },
        },
    };

    const data = {
        labels: variants,
        datasets: decoratedData,
    };
    if (decoratedData === null) {
        return null;
    }

    return <Chart ref={ref} type="bar" options={options} data={data} redraw />;
});

QuantGraphGlobal.displayName = 'QuantGraphGlobal';

export default QuantGraphGlobal;
